import React from "react";
import { Divider, Grid, Container, Button, Form, Icon, Header, Table } from "semantic-ui-react";
import moment from "moment";
import { debounce } from "lodash";
import Wizard from "../Wizard/Wizard";
import { connect } from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { IStoreState } from "../../redux/reducers/root.reducer";
import { emailAddressActions } from "../../redux/actions/emailaddress.actions";
import { startDateActions } from "../../redux/actions/startdate.actions";
import { IProductState } from "../../models/product.interface";
import { productsActions } from "../../redux/actions/products.actions";
import { IAgent } from "../../models/agent.interface";
import { agentActions } from "../../redux/actions/agent.actions";
import { userActions } from "../../redux/actions/user.actions";
import { utmActions } from "../../redux/actions/utm.actions";
import ToolTip from "../shared/ToolTip";
import { validation } from "../../util/validation";
import ErrorMessage from "../Validators/ErrorMessage";
import { IUser } from "../../models/user.interface";
import {IUtm} from "../../models/utm.interface";
import {basketActions} from "../../redux/actions/basket.actions";
import { Basket } from "../../models/basket.model";
import {NavigateFunction} from "react-router-dom";
import address from "../RentalProperty/Address";
import {Address} from "../AddressSelector/Address";

interface IProps {
    addEmailAddress(emailAddress: string): void;
    addStartDate(startDate: string): void;
    email: string;
    agentCode?:string;
    address:Address;
    startDate: string;
    getProducts(agentCode: string | null, from: Date): void;
    getAgentLogo(agentCode: string | null): void;
    checkRelatedPolicies(email: string): void;
    getMinimumStartDate():void;
    clearCart(): void;
    products: IProductState | null;
    user: IUser | null;
    utm: IUtm | null;
    basket: Basket;
    agent: IAgent | null;
    getUtm():any;
    setUtm(campaign:string | null, source: string | null, medium: string | null, adgroup: string | null, keyword: string | null, gclid:string|null, fallback:string|null, agent: string): void;
    navigate:NavigateFunction;
}

interface IState {
    startDate: Date,
    minimumPolicyStartDate:Date|null,
    email: string;
    agentCode:string | null;
    address:Address;
    isLoadingProducts: boolean;
    agent: string | null;
    source: string | null;
    medium: string | null;
    campaign: string | null;
    content: string | null;
    keyword:string | null;
    adgroup:string | null;
    gclid:string|null,
    fallback:string|null,
    noProducts: boolean;
    emailToolTip: string;
    showInvalidEmailError: boolean;
    showInvalidDateError: boolean;
    showHasRelatedPoliciesWarning: boolean;
    test: boolean;
    productError: boolean;
    hasTriedLoadingDefaultProducts:boolean;
    isLoading:boolean;
}

class _StartDate extends React.Component<IProps, IState> {
    
    state: IState = {
        startDate: new Date(),
        minimumPolicyStartDate:null,
        email: "",
        agentCode:"",
        address:new Address(),
        isLoadingProducts: false,
        agent: null,
        source: null,
        medium: null,
        campaign: null,
        content: null,
        keyword:null,
        adgroup:null,
        gclid:null,
        fallback:null,
        noProducts: false,
        emailToolTip:
            "We'll use your email address to check if you already have any landlords insurance with us. It's usually much easier to add your new properties to an existing policy so that your renewals and payments are all in one place. We may also send follow-up communications to this email address if you don't purchase a policy this time around.",
        showInvalidEmailError: false,
        showInvalidDateError: false,
        showHasRelatedPoliciesWarning: false,
        test: false,
        productError: false,
        hasTriedLoadingDefaultProducts:false,
        isLoading:true
    };

    constructor(props: IProps) {
        super(props);
        this.state.isLoading = true;
        this.state.email = this.props.email ? this.props.email : "";
        this.state.address = this.props.address ? this.props.address : new Address();
        this.state.startDate = this.props.startDate ? new Date(this.props.startDate) : new Date();
    }

    componentDidMount() {
        const {
            getAgentLogo,
            getMinimumStartDate,
        } = this.props;
        
        const l = window.location;
        const search = l.search;
        const pathName = l.pathname;
        
        let agent:string = "ABIB";
        let campaign:string|null = null;
        let medium:string|null = null;
        let source:string|null = null;

        let adgroup:string|null = null;
        let keyword:string|null = null;

        let adwords = false;
        let gclid:string|null = null;
        let fallback = false;

        getMinimumStartDate();

        if (search && search.indexOf("utm_campaign=") > -1) {
            let m = search.match(/utm_campaign=([a-zA-Z0-9]+)/);
            campaign = (m !== null ? m[1] : '').toString();
        }

        if (search && search.indexOf("utm_medium=") > -1) {
            let m = search.match(/utm_medium=([a-zA-Z0-9]+)/);
            medium = (m !== null ? m[1] : '').toString();
        }

        if (search && search.indexOf("utm_source=") > -1) {
            let m = search.match(/utm_source=([a-zA-Z0-9]+)/);
            source = (m !== null ? m[1] : '').toString();
            //console.log(source);
            agent = source;
        }

        if (search && search.indexOf("gclid=") > -1) {
            adwords = true;
            let m = search.match(/gclid=([a-zA-Z0-9]+)/);
            gclid = (m !== null ? m[1] : '').toString();
        }
        //console.log("Checking source");
        if (source === null) {
            
            let referrer = document.referrer;

            if (adwords) {
                //console.log("Adwords");
                source = "google";
                medium = "adwords";
                campaign = "gclid";
            }
            else if (referrer) {
                
                //console.log("Referrer");
                
                let referrerUrl = new URL(referrer);
                let referrerHost = referrerUrl.hostname;

                if (typeof referrerHost === "string") {
                    let cleanHost = referrerHost.replace("www.", "");

                    cleanHost = cleanHost.replace("dev.","");

                    if (cleanHost.indexOf("google.") === 0) {
                        //console.log("Google");
                        
                        source = "google";
                        medium = "organic";
                        campaign = "keyword";
                    }
                    else if (cleanHost.indexOf("alanboswell.com") !== 0) {
                        //console.log(referrerHost);
                        
                        source = referrerHost;
                        medium = "referral";
                        campaign = "not set";
                    }
                    else
                    {
                        //console.log("no cleanHost match", cleanHost);
                    }
                }
                else {
                    //console.log("referrerHost is unknown type",referrerHost);
                }
            }
            else {
                //console.log("Direct");
                source = "direct";
                medium = "not set";
                campaign = "not set";
                fallback = true;
            }
        }

        if (search && search.indexOf("ab_campaign=") > -1) {
            campaign = (search.match(/ab_campaign=([a-zA-Z0-9]+)/)?[1]:'').toString();
        }

        if (search && search.indexOf("ab_adgroup=") > -1) {
            adgroup = (search.match(/ab_adgroup=([a-zA-Z0-9]+)/)?[1]:'').toString();
        }

        if (search && search.indexOf("ab_keyword=") > -1) {
            keyword = (search.match(/ab_keyword=([a-zA-Z0-9]+)/)?[1]:'').toString();
        }

        if (!adgroup){
            adgroup = "not set";
        }

        if (!keyword){
            keyword = "not set";
        }

        //if (source !== null) {
                     
        var utmFromWeb = {agent: agent,
            campaign: campaign,
            source: source,
            medium: medium,
            adgroup: adgroup,
            keyword:keyword,
            gclid:gclid,
            fallback:fallback ? "fallback" : null
        }
        
        //console.log("Web UTM values:");
        //console.log(JSON.stringify(utmFromWeb));

        var utmFromCookies = this.props.getUtm().then((r: any) =>{
            
            var utmFromCookies = r;
                       
            // console.log("Cookie values (override web):");
            // console.log(utmFromCookies);

            // default to web values
            var agentValue = utmFromWeb.agent;

            // if last cookie is found and has a value source value use that
            if (utmFromCookies && utmFromCookies.sourceFirst && /^\d+$/.test(utmFromCookies.sourceFirst)) {
                // console.log("Agent overridden from first cookie:" + utmFromCookies.sourceFirst);
                agentValue = utmFromCookies.sourceFirst;
            }
            else {
                if (utmFromCookies && utmFromCookies.sourceLast && /^\d+$/.test(utmFromCookies.sourceLast)) {
                    // console.log("Agent overridden from last cookie:" + utmFromCookies.sourceLast);
                    agentValue = utmFromCookies.sourceLast;
                }
            }

            this.setState(
                {
                    agent: agentValue,
                    campaign: utmFromWeb.campaign,
                    source: utmFromWeb.source,
                    medium: utmFromWeb.medium,
                    adgroup: utmFromWeb.adgroup,
                    keyword:utmFromWeb.keyword,
                    gclid:utmFromWeb.gclid,
                    fallback:utmFromWeb.fallback
                },
                () => {
                    const { campaign, source, medium, adgroup, keyword, gclid, fallback,agent  } = this.state;
                    getAgentLogo(agent);
                    this.props.setUtm(campaign, source, medium, adgroup, keyword, gclid, fallback, agent || "ABIB");

                }

            );
        });
        //}
        //else {
        //    console.log("Source not set");
        //}
    }

    getSnapshotBeforeUpdate(prevProps: IProps, prevState: any) {
        return null;
    }

    componentDidUpdate(prevProps: IProps, prevState: IState, snapshot: any) {

        if (this.props.user) {
            if (this.props.user !== prevProps.user) {
                this.setState({
                    showHasRelatedPoliciesWarning: this.props.user.relatedPolicies
                });
                
                if (this.props.user.minimumPolicyStartDate != undefined && this.props.user.minimumPolicyStartDate != this.state.minimumPolicyStartDate) {
                    this.setState({
                        minimumPolicyStartDate: this.props.user.minimumPolicyStartDate
                    }, () => {
                        if (this.state.minimumPolicyStartDate != null) {
                            //console.log("minimumPolicyStartDate set to " + this.state.minimumPolicyStartDate);
                            this.setState({startDate: new Date(this.state.minimumPolicyStartDate), isLoading: false});
                        }
                    });
                }
            }
        }

        //console.log(this.props.products);
        //console.log(this.state.isLoadingProducts)

        if (this.props.products === null) {
           // console.log("props.products is null")
            return;
        }

        if (this.props.products !== prevProps.products && this.props.products.products.length > 0) {
            this.props.navigate("/property-and-cover",{replace:true});
        }
        else if (this.state.isLoadingProducts
            && this.props.products.error !== (prevProps.products && prevProps.products.error)) {
            this.setState({ isLoadingProducts: false, noProducts: false, productError: true });
        }
        else if (prevProps.products !== this.props.products && this.props.products.products.length === 0 && this.state.isLoadingProducts) {

            if (!this.state.hasTriedLoadingDefaultProducts) {
                this.setState(
                    {
                        agent: "ABIB",
                        campaign:null,
                        medium: null,
                        adgroup:null,
                        keyword:null,
                        gclid:null,
                        fallback:"false"
                    },
                    () => {
                        this.props.getAgentLogo(this.state.agent);
                        const { source, medium, campaign, adgroup, keyword,gclid,fallback } = this.state;
                        this.props.setUtm(campaign, source, medium, adgroup, keyword, gclid, fallback,this.state.agent||"ABIB");

                        this.props.getProducts("ABIB", moment(this.state.startDate).toDate());
                        this.props.clearCart();
                        this.setState({isLoadingProducts: true, productError: false, hasTriedLoadingDefaultProducts: true});
                    });
            }
            else {
                this.setState({isLoadingProducts: false, noProducts: true});
            }
        }

    }

    checkRelatedPoliciesForEmailOnChange = debounce(() => {
        if (validation.isEmail(this.state.email)) {
            this.props.checkRelatedPolicies(this.state.email);
        }
    }, 300);

    validate = (): boolean => {
        let isValid = true;

        if (validation.isEmpty(this.state.email) || !validation.isEmail(this.state.email)) {
            this.setState({ showInvalidEmailError: true });
            isValid = false;
        } else {
            this.setState({ showInvalidEmailError: false });
        }

        if (this.state.startDate == null || validation.isEmpty(this.state.startDate.toString())) {
            this.setState({ showInvalidDateError: true });
            isValid = false;
        } else {
            if (this.state.minimumPolicyStartDate != null && this.state.startDate < this.state.minimumPolicyStartDate) {
                this.setState({ showInvalidDateError: true });
                isValid = false;
            } else {
                this.setState({showInvalidDateError: false});
            }
        }

        return isValid;
    };

    onStep = (step: number) => {
  
      if (step === 3) {
          this.props.navigate("/checkout");
        ///return <Navigate to="/checkout" />;
      }
      if (step === 2) {
          this.props.navigate("/property-and-cover");
       //return <Navigate to="/property-and-cover" />;
      }
      if (step === 1) {
          this.props.navigate("/start");
        //return <Navigate to="/start" />;
      }
    }

    render() {
        const errorMessage = `It looks like you already have a Landlords policy with
    us. If you want to add this cover to your existing
    policy (so it’s all in one place) then call us on
    ${(this.props.agent || {telephone: '01603 967 900'}).telephone}, otherwise just carry on and we’ll issue
    a new policy for this cover`;
        return (
            <>
                <Container>
                    <Wizard activeStep={1} maxActiveStep={0} onClick={this.onStep}></Wizard>
                    <Container className="contentWrapper overflow-visible">
                        <Grid stackable>
                            <Grid.Row>
                                <Grid.Column mobile={16} tablet={10} computer={10}>
                                    <Container className="b2c__card overflow-visible">
                                        <Form>
                                            <Form.Field>
                                                <label>Welcome to Alan Boswell Group Landlord Extras. Here you can purchase Legal Expenses and Rent Protection insurance for
                                                    your buy-to-let property. Remember, you can save even more if you have your Landlord insurance with us. Now…</label>
                                            </Form.Field>
                                        </Form>
                                        <Header as="h2">Let's get started</Header>
                                        <Form style={{ paddingBottom: "100px" }}>
                                            <Form.Field>
                                                <label>
                                                    What is your email address?
                                                    <br />
                                                    (We’ll check if you already have any Landlord’s insurance with us.)
                                                </label>
                                                <Grid>
                                                    <Grid.Row>
                                                        <Grid.Column width={14}>
                                                            <Form.Input
                                                                type="text"
                                                                placeholder="Email address"
                                                                maxLength={50}
                                                                error={this.state.showInvalidEmailError}
                                                                onChange={(event: any) => {
                                                                    this.setState({
                                                                        email: event.target.value,
                                                                        showInvalidEmailError: false,
                                                                    }, () => {
                                                                        this.checkRelatedPoliciesForEmailOnChange();
                                                                    });

                                                                }}
                                                                value={this.state.email}
                                                                onBlur={(event: any) => {
                                                                    if (validation.isEmail(this.state.email)) {
                                                                        this.props.checkRelatedPolicies(this.state.email);
                                                                    } else {
                                                                        this.setState({
                                                                            showInvalidEmailError: true,
                                                                        });
                                                                    }
                                                                }}
                                                            />
                                                            <ErrorMessage show={this.state.showInvalidEmailError} message="This is not a valid email address" />
                                                            <ErrorMessage
                                                                show={this.state.showHasRelatedPoliciesWarning}
                                                                message={errorMessage}
                                                            />
                                                        </Grid.Column>
                                                        <Grid.Column textAlign="center" width={2}>
                                                            <ToolTip cssClasses="">
                                                                <span>{this.state.emailToolTip}</span>
                                                            </ToolTip>
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                </Grid>
                                            </Form.Field>
                                            <Form.Field>
                                                <label>When would you like this insurance cover to start?</label>
                                                {this.state.isLoading &&
                                                <Icon loading name='spinner' />
                                                }
                                                {!this.state.isLoading &&
                                                <DatePicker
                                                  autoComplete="off"
                                                  dateFormat="dd/MM/yyyy"
                                                  minDate={moment(this.state.minimumPolicyStartDate).toDate()}
                                                  maxDate={moment(this.state.minimumPolicyStartDate).add(44, "day").toDate()}
                                                  onChange={(date: any) => {
                                                      this.setState({
                                                          startDate: date,
                                                          showInvalidDateError: false,
                                                      });
                                                  }}
                                                  placeholderText="Start date (DD/MM/YYYY)"
                                                  selected={this.state.startDate}
                                                  className={this.state.showInvalidDateError ? "error-datepicker" : ""}
                                                />
                                                }
                                            </Form.Field>

                                            <Divider hidden />
                                            <Button
                                                size="large"
                                                positive
                                                className="left floated"
                                                onClick={(event: any) => {
                                                    event.preventDefault();
                                                    if (this.validate()) {
                                                        this.props.addEmailAddress(this.state.email);
                                                        const startDate = moment(this.state.startDate);
                                                        this.props.addStartDate(startDate.format());
                                                        //this.setState({ test: true });
                                                        //console.log(this.props)

                                                        this.props.getProducts(this.props.utm !== null ? this.props.utm.agent : this.state.agent, startDate.toDate());
                                                        this.props.clearCart();
                                                       // console.log("Cart cleared");
                                                        this.setState({ isLoadingProducts: true , productError: false});
                                                    }
                                                }}
                                                loading={this.state.isLoadingProducts}>
                                                Next
                                            </Button>
                                            <Divider hidden />
                                            {this.state.noProducts && !this.state.productError && <p>There are no available products at this time.</p>}
                                            {this.state.productError && <p>Unable to load products</p>}
                                        </Form>
                                    </Container>
                                </Grid.Column>
                                <Grid.Column mobile={16} tablet={6} computer={6} className="leftHandGap">
                                    <Container className="b2c__card">
                                        <Header as="h2" className="no-bottom-margin">
                                            Please phone us on <br />
                                            <b>{(this.props.agent && this.props.agent.telephone) || "01603 216399"}</b>
                                        </Header>
                                        <label>...to speak about:</label>
                                        <Table basic="very">
                                            <Table.Body>
                                                <Table.Row verticalAlign="top">
                                                    <Table.Cell>
                                                        <Icon name="arrow right" className="listIcon" />
                                                    Commercial &amp; non-residential properties</Table.Cell>
                                                </Table.Row>
                                                <Table.Row verticalAlign="top">
                                                    <Table.Cell>
                                                        <Icon name="arrow right" className="listIcon" />
                                                    Rentals with no tenant reference checks</Table.Cell>
                                                </Table.Row>
                                            </Table.Body>
                                        </Table>
                                    </Container>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Container>
                </Container>
            </>
        );
    }
}

const mapStateToProps = ({
                             email,
                             startDate,
                             address,
                             agent,
                             products,
                             user,
                             utm,
                             basket
                         }: IStoreState): {
    email: string;
    startDate: string;
    address:Address,
    agent: IAgent | null;
    products: IProductState | null;
    user: IUser | null;
    utm: IUtm | null;
    basket: Basket;
} => {
    return { email, startDate, address, agent, products, user, utm, basket };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        addEmailAddress: (email: string) => {
            return dispatch(emailAddressActions.addEmailAddress(email));
        },
        addStartDate: (startDate: string) => {
            return dispatch(startDateActions.addStartDate(startDate));
        },
        getProducts: (agentCode: string, from: Date) => {
            return dispatch(productsActions.getProducts(agentCode, from));
        },
        getAgentLogo: (agentCode: string) => {
            return dispatch(agentActions.getLogo(agentCode));
        },
        checkRelatedPolicies: (email: string) => {
            return dispatch(userActions.checkRelatedPolicies(email));
        },
        getMinimumStartDate: () => {
            return dispatch(userActions.getMinimumStartDate());
        },
        getUtm:() => {
            return utmActions.getUtm();
        },
        setUtm: (campaign:string, source: string, medium: string, adgroup: string, keyword: string, gclid:string, fallback:string, agent: string) => {
            return dispatch(utmActions.setUtm(campaign, source, medium, adgroup, keyword, gclid, fallback, agent));
        },
        clearCart: () => dispatch(basketActions.clearBasket())
    };
};

export const StartDate = connect(mapStateToProps, mapDispatchToProps)(_StartDate);
